import { render, staticRenderFns } from "./requirementList.vue?vue&type=template&id=6ea49fd8&"
import script from "./requirementList.vue?vue&type=script&lang=js&"
export * from "./requirementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports